// Presentational-only formatting for chip labels over open wire strings: normalize snake_case
// word separators to spaces and uppercase the first letter ('stored' → 'Stored', 'non_collected'
// → 'Non collected'). Statuses are fail-open, so anything unmapped still has to read decently. The
// canonical wire/eligibility spelling stays underscored — this touches display only. Empty string
// passes through untouched.
export function capitalize(s: string): string {
  if (!s) return s;
  const spaced = s.replace(/_/g, ' ');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
